import { EVENT_TYPES } from '../../constants/personHistoryConstants';
import React from 'react';
import { Box, Typography } from '@material-ui/core';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';

const PersonHistoryChangesCell = ({ changes, event }) => {
  if (!changes || !Object.keys(changes).length) {
    return <span>—</span>;
  }
  const isCreatedEvent = event === EVENT_TYPES.CREATED;

  return (
    <Box className="person-history-tab__ChangesContainer">
      {Object.entries(changes).map(([field, { label, from, to }]) => (
        <Box key={field}>
          <Typography variant="caption">
            <strong>
              {label}
              {': '}
            </strong>
          </Typography>
          <Typography variant="caption">
            {isCreatedEvent ? (
              <span>{String(to)}</span>
            ) : (
              <>
                <span>{String(from)}</span>
                <span>
                  {' '}
                  <ArrowRightAltIcon />{' '}
                </span>
                <span>{String(to)}</span>
              </>
            )}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default PersonHistoryChangesCell;
